import {FC} from 'react';

import {Box, IconButton, Typography} from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';

import {CloseIcon} from 'assets/icons/closeIcon';

export interface BasketDialogTitleProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
}

export const BasketDialogTitle: FC<BasketDialogTitleProps> = ({title, subtitle, onClose}) => (
  <DialogTitle>
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box>
        <Typography fontWeight={600} fontSize="1.2rem">
          {title}
          {subtitle && (
            <>
              <br></br>
              {subtitle}
            </>
          )}
        </Typography>
      </Box>{' '}
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Box>{' '}
  </DialogTitle>
);
